import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { StripeService } from 'ngx-stripe';
import { ToolsService } from '../../tools/tools.service';
import * as moment from 'moment';
import { PanierService } from "../../manage/panier/panier.service";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MyStripeService {

  private currCard: BehaviorSubject<any> = new BehaviorSubject(null);

  private stripeKey: BehaviorSubject<any> = new BehaviorSubject(null);

  private KeyClientStripe: BehaviorSubject<any> = new BehaviorSubject(null);

  private currPaymentMethodStripe: BehaviorSubject<any> = new BehaviorSubject(null);

  private ProgressPayment: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private baseClient: BaseclientService,
    private stripeService: StripeService,
    private tools: ToolsService
  ) { }

  getStripeKey(): Observable<string> {
    return this.stripeKey.asObservable();
  }

  // CARDS

  getCurrCard(): Observable<any> {
    return this.currCard.asObservable();
  }

  setCurrCard(val: any): void {
    this.currCard.next(val);
  }

  removeCurrCard(): void {
    this.currCard.next(null);
  }

  setDefaultCard(cards: any): void {
    if (cards && cards.length > 0) {
      const defaultCard = cards.filter((card: any) => card.is_default === 1);
      defaultCard.length > 0 ? this.setCurrCard(defaultCard[0]) : this.setCurrCard(cards[0]);
    }
    else {
      this.removeCurrCard();
    }
  }

  parseCards(cards: any) {
    if (cards && cards.length > 0)
      cards.map((card: any) => {
        if (card.type == 'card')
          this.parseCard(card);
      });
    return cards;
  }

  /**
   * Configuration de la clé publique Stripe selon l'utilisateur connecté
   * @param userKey
   */
  setKeyByUser(userKey: string) {
    this.stripeKey.next(environment.stripe.stripePublicKey);
  }

  parseCard(card: any) {

    // const baseLink = "assets/img/card-logos/60X50/";
    // const type = (card.card.brand).replace(" ", "").toLowerCase();
    let imgCard = [
      'ALIPAY', 'AMAZON', 'AMEX',
      'BANCONTACT', 'DINERS', 'DISCOVER',
      'IDEAL', 'JCB', 'VISA', 'MASTERCARD',
      'APPLE PAY', 'GOOGLE PAY'
    ];

    const baseLink = "assets/img/refonte-logo/";
    const type = (card.card.brand).replace(" ", "").toUpperCase();
    let imagename = imgCard.find((value: any) => value == type);
    let imageType = imagename ? imagename : 'creditcard';
    const format = ".png";
    card.momentary = false;
    card.card.logo_src = baseLink + imageType + format;

  }

  createMomentaryCard(card: any) {
    this.parseCard(card);
    card.momentary = true;
    this.currCard.next(card);
    return card;
  }

  createCard(cardid: string): Observable<any> {
    const params = {
      payment_method_id: cardid,
    }
    return from(this.baseClient.postBase("createCardSCA", params))
      .pipe(

        map(data => {

          if (data.code === 0) {

            this.parseCards(data.cards);

            if (!this.currCard.getValue()) {
              this.setDefaultCard(data.cards);
            }

          }

          return data;

        })
      )
  }

  /*getCards(): Observable<any> {
    return from(this.baseClient.getBase("getCardsSCA")).pipe(
      map(data => {

        this.parseCards(data.cards);
        this.setDefaultCard(data.cards);
        return data.cards;
      })
    )
  }*/

  deleteCard(card: any): Observable<any> {
    const params = {
      payment_method_id: card.id
    };
    return from(this.baseClient.postBase("deleteCardSCA", params))
      .pipe(
        map(data => {

          if (data.code === 0) {

            this.parseCards(data.cards);

            if (this.currCard.getValue().id === card.id) {
              this.removeCurrCard();
              this.setDefaultCard(data.cards);
            }

          }

          return data;

        })
      )
  }

  //stripe payment method

  getDefaultPaymentMethodObser(): Observable<any> {
    return this.currPaymentMethodStripe.asObservable();
  }

  setDefaultPaymentMethodObser(val: any): void {
    this.currPaymentMethodStripe.next(val);
  }

  /**
     * @description set current  and default  payment method stripe
     */

  setDefaultPaymentMethod(payment_methods: any, default_payment_method?: any): void {

    if (payment_methods.length > 0) {
      const defaultPaiementMethod = payment_methods.find((payment_method: any) => payment_method.id === default_payment_method);
      let PaiementMethod = defaultPaiementMethod ? defaultPaiementMethod : payment_methods[0];
      this.setDefaultPaymentMethodObser(PaiementMethod);
      this.setCurrCard(PaiementMethod);
    }
  }

  /**
    * @description get ClientKeyPayIntentOrder
    */
  getClientKeyPayIntent(currentAmountTotal: any, rememberSavedPayment: any, metadata_provenance: any, id_user: any = null, pof_id?: any,paymentIntent?:any): Observable<any> {

    let params: any = {
      pos_id: pof_id,
      id_user: id_user,
      amount: currentAmountTotal,
      rememberSavedPayment: rememberSavedPayment,
      metadata: metadata_provenance
    };
    if (metadata_provenance == 1) {
      params['basket'] = this.tools.getStor(PanierService.TAG_STORAGE) ? this.tools.getStor(PanierService.TAG_STORAGE) : null;
      params['fidelityDiscountUsed'] = this.tools.getStor("credit_fid") ? this.tools.getStor("credit_fid") : null;
      params['order_id'] = this.tools.getStor("order_id");
    }
    if(paymentIntent){
      params['paymentIntent'] = paymentIntent;
    }

    params["payment_intent_id_saved"] = this.tools.getStor("ClientKeyPayIntenCard")?this.tools.getStor("ClientKeyPayIntenCard").id:null

    // return from(this.baseClient.postBase("getClientKeyPayIntent", params)).pipe(
    return from(this.baseClient.postBase("fulle_stripe/get-client-key-pay-intent", params)).pipe(
      map(data => {
        return data;
      })
    )
  }

  // getClientKeyPayIntent2({
  //   amount,
  //   rememberSavedPayment,
  //   metadata_provenance,
  //   id_user,
  //   // key_stripe,
  //   pos_id,
  //   paymentIntent
  // }: {
  //   amount: number;
  //   rememberSavedPayment: boolean;
  //   metadata_provenance: number;
  //   id_user: number;
  //   // key_stripe: any;
  //   pos_id: number;
  //   paymentIntent?: string;
  // })
  //   : Observable<any> {
  //   let params: any = {
  //     pos_id: pos_id,
  //     client: id_user,
  //     // id_stripe: key_stripe,
  //     amount: amount,
  //     rememberSavedPayment: rememberSavedPayment,
  //     metadata: metadata_provenance,
  //   };
  //   if (metadata_provenance == 1) {
  //     // le client a-t-il un précédent panier chez nous ?
  //     params['basket'] = this.tools.getStor("basket") ? this.tools.getStor("basket") : null;
  //     // a-t-il utilisé un code promo ?
  //     params['fidelityDiscountUsed'] = this.tools.getStor("credit_fid") ? this.tools.getStor("credit_fid") : null;
  //     // dans tous les cas ou recupere les order_id s'il y en a :
  //     params['order_id'] = this.tools.getStor("order_id");
  //   }
  //   if (paymentIntent) {
  //     params['paymentIntent'] = paymentIntent;
  //   }

  //   params["payment_intent_id_saved"] = this.tools.getStor("ClientKeyPayIntenCard") ? this.tools.getStor("ClientKeyPayIntenCard").id : null
  //   return from(this.baseClient.postBase("getClientKeyPayIntent", params)).pipe(
  //     map(data => {
  //       return data;
  //     })
  //   )
  // }

  /**
   * Récupération d'une intention de paiement existante
   * @param payment_intent intention de paiement
   */
  getPayintentPaiement(payment_intent: string) {

    let params: any = {
      payment_intent: payment_intent
    };

    return from(this.baseClient.postBase("getPayintentPaiement", params)).pipe(
      map(data => {
        return data;
      })
    )
  }

  /**
  * @description get check Order Payment
  */
  checkOrderPayment(id_order: any = null, id_data: any = null, payment_intent: any): Promise<any> {
    const params = {
      id_data: id_data,
      payment_intent: payment_intent,
      id_order: id_order
    };

    return this.baseClient.postBase("checkOrderPayment", params);

  }

  getOrderPaymentStripe(id_order: any = null, id_data: any, payment_intent: any): Promise<any> {
    const params = {

      payment_intent: payment_intent,
      id_data: id_data,
      id_order: id_order

    };

    return this.baseClient.postBase("getOrderPaymentStripe", params);
  }



  getLetteringPaymentStripe(id_data: any, payment_intent: any): Promise<any> {
    const params = {
      payment_intent: payment_intent,
      id_data: id_data

    };
    return this.baseClient.postBase("getLetteringPaymentStripe", params);
  }


  checkLetteringPayment(id_data: any = null, payment_intent: any): Promise<any> {
    const params = {
      id_data: id_data,
      payment_intent: payment_intent
    };

    return this.baseClient.postBase("checkLetteringPayment", params);

  }



  /**
      * @description get all PaymentMethod stripe saved
      */

  getPaymentMethod(nodefault?: any): Observable<any> {


    return from(this.baseClient.getBase("getCustomerMethodsPayment")).pipe(
      map(data => {

        if (data.paymentMethods && data.paymentMethods.length > 0) {
          this.parseCards(data.paymentMethods);
          if (!nodefault) {
            this.setDefaultPaymentMethod(data.paymentMethods, data.defaultpaymentMethod.default_payment_method)
          }
        }
        else {
          this.removeCurrCard();
        }

        return data.paymentMethods ? data.paymentMethods : [];

      })
    )
  }


  /**
      * @description   updateCustomerPaymentsMethod  set default PaymentMethod  in customer

      */

  updateCustomerPaymentsMethod(id_pm: any): Observable<any> {
    const params = {
      payment_method_id: id_pm,
    }


    return from(this.baseClient.postBase("updateCustomerPaymentsMethodDefault", params)).pipe(
      map(data => {

        return data.customer;

      })
    )
  }



  createPaymentMethod(cardid: string): Observable<any> {
    const params = {
      payment_method_id: cardid,
    }
    return from(this.baseClient.postBase("createCustomerMethodPayment", params))
      .pipe(

        map(data => {

          if (data.code === 0) {

            this.parseCards(data.paymentMethods);
            this.setDefaultPaymentMethod(data.paymentMethods, data.defaultpaymentMethod.default_payment_method);

          }
          return data;
        })
      )
  }




  /**
      * @description  delete one PaymentMethod

      */
  deletePaymentMethod(pms: any): Observable<any> {


    const params = {
      payment_method_id: pms.id
    };

    return from(this.baseClient.postBase("deleteCustomerMethodPayment", params))
      .pipe(
        map(data => {

          if (data.code === 0) {


            this.parseCards(data.paymentMethods);



            if (this.currCard && this.currCard.getValue().id === pms.id) {

              this.removeCurrCard();

            }

            this.setDefaultPaymentMethod(data.paymentMethods, data.defaultpaymentMethod.default_payment_method);


          }

          return data;

        })
      )
  }

  progressInterval: any = null;
  timeProgressInterval = 1500;
  timeMaxWaitResp = 15;

  // ProgressPayment

  getProgressPaymentStripe(): Observable<any> {
    return this.ProgressPayment.asObservable();
  }

  setProgressPaymentStripe(val: any): void {
    this.ProgressPayment.next(val);
  }

  /**
     * @description  check is Time not Exceeded
     *
     */

  checkTimeExceeded(nowPayment?: any) {

    let result = false;


    let startTime = nowPayment;
    let now = moment();
    let endTime = now.diff(startTime, 'seconds');

    if (endTime > this.timeMaxWaitResp) {
      result = true;
    }
    return result;
  }


  /**
    * @description start interval
    */

  startIntervalProgressPayment() {
    this.progressInterval = setInterval(() => {

      if (this.progressInterval) {
        this.setProgressPaymentStripe(true);
      }
    }, this.timeProgressInterval);
  }
  /**
     * @description stop interval
     */
  stopIntervalProgressPayment() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
      this.setProgressPaymentStripe(false);
    }
  }













}



